<template>
  <ion-page>
    <ion-header class="ion-no-border" translucent>
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
        <ion-button
          @click="$store.commit('setOpenMenu', true)"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"
          ></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <ion-grid class="b-faq">
        <h1>FAQ</h1>
        <collapsible>
          <template v-slot:title>
            <b>Was ist der Roodie.Check?</b>
          </template>
          <div class="ion-margin-bottom">
            Beim Roodie.Check erfragen wir Ihre mentalen oder körperlichen
            Beschwerden und gesundheitlichen Anliegen. Er dient der Vorbereitung
            von Experten, die wiederum eine bestmögliche, individuelle
            Behandlung für Sie suchen bzw. erbringen wollen. Diese Erhebung
            können Sie mit einem ausgewählten Servicepartner im Vorfeld einer
            Servicenutzung teilen. Nach Beendigung des Roodie.Checks werden Ihre
            angegebenen Beschwerden zusammengefasst, aufgelistet und als
            Roodie.Check in Ihrer Roodie ARAG App gespeichert.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Wie kann ich Roodie nutzen?</b>
          </template>
          <div class="ion-margin-bottom">
            Die Roodie ARAG App ist für Vollversicherte der ARAG
            Krankenversicherungs-AG und deren Familienmitglieder kostenfrei
            nutzbar. Unter Angabe Ihrer Versicherungsvertragsnummer und
            persönlicher Daten, können Sie sich schnell und einfach bei Roodie
            registrieren und sofort mit der Verbesserung Ihrer Gesundheit
            beginnen.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Wie funktioniert die Registrierung bei Roodie?</b>
          </template>
          <div class="ion-margin-bottom">
            Für die Registrierung müssen Sie bei der ARAG eine
            Krankenvollversicherung haben. Mit der Angabe Ihrer persönlichen
            Daten und Ihrer Versicherungsnummer, kann die Registrierung
            unkompliziert und schnell vorgenommen werden.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Kann ich bei allen Schmerzen den Roodie.Check machen?</b>
          </template>
          <div class="ion-margin-bottom">
            Sie können bei jeglichen mentalen und körperlichen
            Beschwerden/Anliegen den Roodie.Check machen. Wir decken fast das
            komplette Spektrum an Beschwerdemöglichkeiten ab. Sollten sehr
            spezifische Bereiche nicht abgedeckt sein, werden Sie während des
            Roodie.Checks darüber informiert. In Notfällen kontaktieren Sie
            bitte Ihren Hausarzt oder wählen Sie die Nummer 112 für den
            Rettungsdienst oder 116117 für den ärztlichen Bereitschaftsdienst.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Wann sollte ich den Roodie.Check machen?</b>
          </template>
          <div class="ion-margin-bottom">
            Bei gesundheitlichen Beschwerden, Unsicherheit mit einer Diagnose
            und Wunsch eine Zweitmeinung zu erhalten, oder wenn Sie einfach nur
            einen neuen Facharzt suchen, oder den bestehenden Facharzt wechseln
            möchten, lohnt es sich den Roodie.Check zu machen.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Kann ich einen gebuchten Zahnarzttermin kostenlos stornieren?</b>
          </template>
          <div class="ion-margin-bottom">
            Ja, alle gebuchten Zahnarzttermine können bis zu einem bestimmten
            Zeitpunkt kostenlos storniert werden.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Erfolgt die Hilfe/Arztsuche neutral?</b>
          </template>
          <div class="ion-margin-bottom">
            Die medizinische Hilfe bzw. Arztsuche erfolgt über unsere Partner,
            völlig neutral und unbeeinflusst. Die für Sie bestmögliche
            medizinische Betreuung wird von den Partnern, basierend auf Ihrem
            Roodie.Check oder allfälliger zusätzlicher Erfragungen, passend zu
            Ihren individuellen persönlichen Gegebenheiten vorgeschlagen.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Wie oft kann ich den Roodie.Check machen?</b>
          </template>
          <div class="ion-margin-bottom">
            Den Roodie.Check können Sie uneingeschränkt nutzen.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Wann entstehen Kosten für mich?</b>
          </template>
          <div class="ion-margin-bottom">
            Als Vertragspartner der ARAG stehen Ihnen unsere Roodie-Services
            kostenlos zu Verfügung. Die Kosten für eine Behandlung, etwa bei
            einem Arzt, werden von der ARAG im tariflichen Rahmen übernommen.
            Die Abrechnungsmöglichkeiten können sich je nach Partner
            unterscheiden. Hinweise diesbezüglich erhalten Sie in der Roodie App
            und beim jeweiligen Servicepartner.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Kostet die Nutzung der Roodie ARAG App etwas?</b>
          </template>
          <div class="ion-margin-bottom">
            Der App Download, die Registrierung sowie die Nutzung der Services
            ist für Sie kostenfrei.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Werden meine Gesundheitsdaten weitergeleitet? </b>
          </template>
          <div class="ion-margin-bottom">
            Sie alleine bestimmen, was mit Ihren Gesundheitsdaten passiert. Nur
            mit Ihrer eindeutigen Zustimmung können Ihre Gesundheitsdaten mit
            den Roodie-Partnern, welche die von Ihnen ausgewählten Leistungen
            erbringen, geteilt werden.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Wo und wie werden meine Daten gespeichert?</b>
          </template>
          <div class="ion-margin-bottom">
            Die Sicherheit Ihrer Daten hat bei uns höchste Priorität, daher
            werden Ihre Daten in einem elektronischen Safe sicher gespeichert.
            Dieser Safe verfügt über die modernsten Verschlüsselungsmethoden und
            über eine Datenbankarchitektur, welche den Zugriff für andere nicht
            möglich macht. Die Hoheit über diese Daten haben immer Sie. Das
            heißt, jegliche Weiterleitung, Änderung, Löschung, etc. wird von
            Ihnen bestimmt. Wir sind auch rechtlich dazu verpflichtet die
            deutsche und EU-weiten Datenschutzrichtlinien einzuhalten. In den
            Einstellungen unter dem Punkt „Informationen“ können Sie die
            Datenschutzbestimmungen einsehen.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Sind meine Gesundheitsdaten sicher?</b>
          </template>
          <div class="ion-margin-bottom">
            Ihre Gesundheitsdaten werden sicher in einem Safe gespeichert,
            welcher über die neuesten Technologien in Bezug auf Sicherheit
            verfügt. Dadurch wird garantiert, dass niemand anderer Zugriff auf
            Ihre Daten hat. Somit wird ein Datenmissbrauch sowie ein Verbleib
            Ihrer Daten im europäischen Raum sichergestellt.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Werden meine Gesundheitsdaten der ARAG übermittelt?</b>
          </template>
          <div class="ion-margin-bottom">
            Nein, Gesundheitsdaten werden generell nicht übermittelt
            beziehungsweise hat die ARAG kein Befugnis Ihre Daten einzusehen.
            Einer Übermittlung von Daten müssen Sie persönlich zustimmen, wie
            etwa im Zuge des Roodie.Checks und der im Bedarfsfall damit
            verbundenen Inanspruchnahme der Unterstützung durch das ARAG Case
            Management bei einem gesundheitlichen Anliegen.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Kann ich meine Daten jederzeit löschen?</b>
          </template>
          <div class="ion-margin-bottom">
            Die Löschung Ihres Profils und die damit einhergehende Löschung der
            Daten können Sie jederzeit durchführen. Wir versichern eine
            vollständige personenbezogene Datenlöschung, sodass keine
            Rückverfolgung und kein Zusammenhang von Daten mit Ihrer Person
            vorgenommen werden kann. Eine Wiederherstellung Ihrer Daten ist
            danach nicht mehr möglich.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Wo finde ich die Versicherungsnummer?</b>
          </template>
          <div class="ion-margin-bottom">
            Die Versicherungsnummer finden Sie in Ihrem
            <a href="#" @click.prevent="$router.push({ name: 'profil' })"
              >Profil</a
            >
            und auf den Briefen der ARAG direkt unter „Betreff“. Für weitere
            diesbezügliche Fragen, kontaktieren Sie einfach einen
            Servicemitarbeiter der ARAG unter
            <a href="tel:+491531021600">01 531021600</a>. Er wird Ihnen mit
            Sicherheit weiterhelfen können.
            <!-- Die Versicherungsnummer finden Sie auf den Briefen der ARAG direkt
            unter „Betreff“ oder gehen Sie in Ihrer ARAG Gesundheits-App unter
            „Mein Profil“. Für weitere diesbezügliche Fragen, kontaktieren Sie
            einfach einen Servicemitarbeiter der ARAG unter
            <a href="tel:+491531021600">01 531021600</a>. Er wird Ihnen mit
            Sicherheit weiterhelfen können. -->
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Wo finde ich meine Roodie.Checks?</b>
          </template>
          <div class="ion-margin-bottom">
            Ihre Roodie.Checks werden alle im Menü unter „Roodie.Safe“
            gespeichert. Hier haben Sie auch die Möglichkeit die Roodie.Checks
            zu bearbeiten, zu teilen, als PFD zu speichern und noch vieles mehr.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Ich habe meine Login-Daten vergessen, was nun?</b>
          </template>
          <div class="ion-margin-bottom">
            Sollten Sie nur Ihr Passwort vergessen haben, können Sie auf der
            Login-Seite unter „Passwort vergessen“, ein neues Passwort kreieren.
            Sollten Sie nicht mehr wissen, mit welcher E-Mail Adresse Sie sich
            registriert haben, dann können Sie unter Profil diese einsehen und
            bei Bedarf ändern.
            <!-- Sollten Sie nur Ihr Passwort vergessen haben, können Sie auf der
            Login-Seite unter „Passwort vergessen“, ein neues Passwort kreieren.
            Sollten Sie nicht mehr wissen mit welcher E-Mail Adresse Sie sich
            registriert haben, dann nehmen Sie einfach Kontakt mit uns auf unter
            <a href="mailto:hallo@roodie-health.com">hallo@roodie-health.com</a
            >. -->
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Bekomme ich nach dem Roodie.Check eine Diagnose?</b>
          </template>
          <div class="ion-margin-bottom">
            Nein, Diagnosen werden direkt nach dem Roodie.Check nicht erstellt.
            Der Roodie.Check dient jedoch zum einen als Vorbereitung für unserer
            Partner, um eine individuelle und gezielte Arztsuche für Sie zu
            gewährleisten. Zum anderen als Vorinformation für das Erstgespräch
            beim Arzt für die darauffolgende Diagnose und um die Behandlungsform
            für Sie bestmöglich anpassen zu können. In weiterer Folge können
            dadurch auch Wartezeiten vor Ort verkürzt werden, da der Arzt durch
            den Roodie.Check bereits über Ihre Beschwerden vorinformiert wurde.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b
              >Ich habe einen Rückruf von BetterDoc gebucht, bekomme diesen aber
              nicht.</b
            >
          </template>
          <div class="ion-margin-bottom">
            Bitte nehmen Sie mit uns
            <a href="#" @click.prevent="$router.push({ name: 'kontakt' })"
              >Kontakt</a
            >
            mit uns auf, damit wir Ihnen rasch weiterhelfen können.
            <!-- Bitte nehmen Sie mit uns Kontakt auf unter
            <a href="mailto:hallo@roodie-health.com">hallo@roodie-health.com</a>
            damit wir Ihnen so schnell als möglich weiterhelfen können. -->
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Was ist der Live-Chat und wie kann ich diesen nutzen?</b>
          </template>
          <div class="ion-margin-bottom">
            Den Live-Chat können Sie optional wählen, bei dem Sie direkt von
            einem medizinischen Fachpersonal der BetterDoc GmbH zu Ihren
            gesundheitlichen Anliegen befragt werden. Im Konkreten bedeutet das,
            dass Sie in Echtzeit mit einem medizinischen Fachpersonal der
            BetterDoc GmbH kommunizieren. Diese Möglichkeit steht Ihnen
            wochentags von 9-17 Uhr zur Verfügung. Einen Hinweis, dass Sie
            dieses Service nutzen können, erhalten Sie innerhalb der Roodie App.
          </div>
        </collapsible>
        <collapsible>
          <template v-slot:title>
            <b>Wie nehme ich Kontakt bei Problemen mit der Roodie App auf?</b>
          </template>
          <div class="ion-margin-bottom">
            Bei jeglichen technischen Problemen aber auch anderen Anliegen,
            schicken Sie uns bitte eine
            <a href="#" @click.prevent="$router.push({ name: 'kontakt' })"
              >Nachricht</a
            >. Wir werden uns schnellstmöglich um Ihr Anliegen kümmern und
            gegebenenfalls die Probleme so schnell als möglich bearbeiten und
            beheben.
            <!-- Bei jeglichen technischen Problemen aber auch anderen Anliegen,
            schicken Sie uns bitte ein Mail an
            <a href="mailto:hallo@roodie-health.com">hallo@roodie-health.com</a
            >. Wir werden uns schnellstmöglich um Ihr Anliegen kümmern und
            gegebenenfalls die Probleme so schnell als möglich bearbeiten und
            beheben. -->
          </div>
        </collapsible>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  // IonTitle,
  IonButtons,
  IonContent,
  //   IonList,
  // IonListHeader,
  //   IonItem,
  //   IonLabel,
  // IonNote,
  IonButton,
  IonIcon,
  //   IonText,
  IonGrid,
  IonBackButton,
  //   IonRow,
  //   IonCol,
} from "@ionic/vue";
import { chevronBack } from "ionicons/icons";
import Collapsible from "@/components/Collapsible";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    // IonTitle,
    IonButtons,
    IonContent,
    // IonList,
    // IonListHeader,
    // IonItem,
    // IonLabel,
    // IonNote,
    IonButton,
    IonIcon,
    // IonText,
    IonGrid,
    // IonRow,
    // IonCol,
    Collapsible,
    IonBackButton,
  },
  methods: {},
  setup() {
    return { chevronBack };
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.b-faq {
  .c-collapsible {
    margin-top: 20px;
  }
}
</style>
